import { connect } from 'react-redux';
import Homepage from './HomePage';

function mapStateToProps({ config, geoIp, marketing }) {
  return {
    country: geoIp.geoIpInfo.country,
    imagesHost: config.imagesHost,
    platformTotals: marketing.platformTotals,
    savedByUser: marketing.savedByUser,
  };
}

export default connect(mapStateToProps)(Homepage);
